import { useCallback, useMemo } from 'react';
import { isAdminSite } from '../../../utils';
import { loadBerryApp } from '../helpers';
import useBerryHelpers from './useBerryHelpers';
import { TBerryEventHandlers } from '../types';
import useLocationChangeSync from '../../../hooks/useLocationChangeSync';

function useBerry(auth?: any, eventHandlers?: TBerryEventHandlers) {
  const helpers = useBerryHelpers();
  const isBerryChatEnabled = auth?.isBerryChatEnabled;

  const { updateProperties } = helpers;

  const onLocationChange = useCallback(() => {
    updateProperties({
      page_url: window.location.href,
    });
  }, [updateProperties]);

  useLocationChangeSync(onLocationChange);

  const config = useMemo(
    () => ({
      name: auth?.user.name,
      userEmail: auth?.user.email,
      userId: auth?.user.id,
      isAdmin: isAdminSite(),
      customerId: auth?.customerId,
      primaryColor: auth?.primaryColor,
      toggleIconUrl: auth?.toggleIconUrl,
      berryBotUrlPath: auth?.berryBotUrlPath,
      parentElementId: auth?.parentElementId,
      isBerryChatEnabled: auth?.isBerryChatEnabled,
      customProps: {
        ls_name: auth?.company?.name,
        ls_link: auth?.company?.learningSite || window.location.host,
        page_url: window.location.href,
        username: auth?.user.username,
        user_email: auth?.user.email,
        user_id: auth?.user.id,
        cname: auth?.customerId,
      },
    }),
    [auth]
  );

  const init = useCallback(async () => {
    if (isBerryChatEnabled) {
      await loadBerryApp(config, eventHandlers);
    }
  }, [config, isBerryChatEnabled, eventHandlers]);

  return {
    init: init,
    ...helpers,
  };
}

export default useBerry;
